"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSelectedIndicator = exports.StyledLayoutWrapper = exports.StyledTitleContent = exports.StyledTabTitle = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../../../style/themes/base"));

var _icon = _interopRequireDefault(require("../../../icon/icon.style"));

var _validationIcon = _interopRequireDefault(require("../../../../__internal__/validations/validation-icon.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledTitleContent = _styledComponents.default.div`
  outline: none;

  ${({
  theme,
  size,
  borders,
  position,
  noLeftBorder,
  noRightBorder,
  isTabSelected,
  hasSiblings,
  href,
  error,
  warning,
  info,
  alternateStyling
}) => (0, _styledComponents.css)`
    line-height: 20px;
    margin: 0;

    ${href && (0, _styledComponents.css)`
      color: ${theme.text.color};
      display: block;
      text-decoration: none;

      [type="link"] {
        width: 16px;
        margin-left: 8px;
        height: 16px;
        color: inherit;
        margin-top: -2px;
      }
    `}

    ${borders && (0, _styledComponents.css)`
      border-top: 1px solid ${theme.tab.background};
      border-left: 1px solid ${theme.tab.background};
      border-right: 1px solid ${theme.tab.background};

      ${position === "left" && (0, _styledComponents.css)`
        border-bottom: 1px solid ${theme.tab.background};
        ${!alternateStyling && `margin-right: -1px;`}
      `}

      ${noLeftBorder && (0, _styledComponents.css)`
        border-left: none;

        ${!noRightBorder && (0, _styledComponents.css)`
          border-right: 1px solid ${theme.tab.background};
        `}
      `}

      ${noRightBorder && (0, _styledComponents.css)`
        border-right: none;
      `}
    `}

    ${size === "large" && position === "top" && (0, _styledComponents.css)`
      padding: 10px 24px;
      font-size: 16px;
      ${isTabSelected && !hasSiblings && !(error || warning || info) && (0, _styledComponents.css)`
        padding-bottom: 6px;
      `}
    `}

    ${size === "large" && position === "left" && (0, _styledComponents.css)`
      font-size: 16px;
      padding: 22px 24px;
      ${!isTabSelected && !alternateStyling && (error || warning || info) && `margin-right: -2px;`}
    `}

    ${size === "default" && (0, _styledComponents.css)`
      padding: 10px 16px;
      ${isTabSelected && !(error || warning || info) && position === "top" && (0, _styledComponents.css)`
        padding-bottom: 8px;
      `}

      ${position === "left" && !isTabSelected && !alternateStyling && (error || warning || info) && `margin-right: -2px;`}
    `}
  `}

  ${({
  position,
  warning,
  info,
  theme,
  size,
  hasCustomLayout
}) => (warning || info) && (0, _styledComponents.css)`
      outline: 1px solid;
      outline-offset: -1px;

      ${info && !warning && (0, _styledComponents.css)`
        outline-color: ${theme.colors.info};
      `}

      ${warning && (0, _styledComponents.css)`
        outline-color: ${theme.colors.warning};
      `}

    ${position === "top" && (0, _styledComponents.css)`
        border-bottom-color: transparent;
      `}

    ${position === "left" && (0, _styledComponents.css)`
        border-right-color: transparent;
        padding-right: ${size === "large" ? "26px;" : "18px;"};
      `}
      
    &:hover {
        outline: 1px solid;
        outline-offset: -1px;

        ${info && !warning && (0, _styledComponents.css)`
          outline-color: ${theme.colors.info};
        `}

        ${warning && (0, _styledComponents.css)`
          outline-color: ${theme.colors.warning};
        `}

      ${position === "top" && (0, _styledComponents.css)`
          border-bottom-color: transparent;

          ${hasCustomLayout && (0, _styledComponents.css)`
            padding-bottom: 2px;
          `}
        `}

      ${position === "left" && (0, _styledComponents.css)`
          border-right-color: transparent;
          padding-right: ${size === "large" ? "26px;" : "18px;"};
        `}
      }
    `}

  ${({
  error,
  theme,
  position,
  size,
  hasCustomLayout
}) => error && (0, _styledComponents.css)`
      outline: 2px solid ${theme.colors.error};
      outline-offset: -2px;

      ${position === "top" && (0, _styledComponents.css)`
        border-bottom-color: transparent;
      `}

      ${position === "left" && (0, _styledComponents.css)`
        border-right-color: transparent;
        padding-right: ${size === "large" ? "26px;" : "18px;"};
      `}
    
    &:hover {
        outline: 2px solid ${theme.colors.error};
        outline-offset: -2px;
        ${position === "top" && (0, _styledComponents.css)`
          border-bottom-color: transparent;

          ${hasCustomLayout && (0, _styledComponents.css)`
            padding-bottom: 2px;
          `}
        `}

        ${position === "left" && (0, _styledComponents.css)`
          border-right-color: transparent;
          padding-right: ${size === "large" ? "26px;" : "18px;"};
        `}
      }
    `}

  ${({
  hasSiblings,
  hasCustomLayout,
  error,
  warning,
  info,
  size,
  isTabSelected,
  position
}) => hasSiblings && !hasCustomLayout && position === "top" && (0, _styledComponents.css)`
      height: 20px;

      ${size === "default" && (0, _styledComponents.css)`
        padding-top: 10px;
        padding-bottom: 10px;

        ${!(error || warning || info) && isTabSelected && (0, _styledComponents.css)`
          padding-bottom: 8px;
        `}
      `}

      ${size === "large" && (0, _styledComponents.css)`
        padding-top: 10px;
        padding-bottom: 10px;

        ${!(error || warning || info) && isTabSelected && (0, _styledComponents.css)`
          padding-bottom: 6px;
        `}
      `}
    `}

  ${({
  hasCustomLayout,
  error,
  warning,
  info,
  position,
  size,
  isTabSelected
}) => hasCustomLayout && (0, _styledComponents.css)`
      display: flex;

      ${position === "left" && (0, _styledComponents.css)`
        padding: ${size === "large" ? "2px;" : "0px;"}
          ${isTabSelected && (0, _styledComponents.css)`
            padding-right: 0px;
          `}
          ${(error || warning || info) && (0, _styledComponents.css)`
            padding-right: ${size === "large" ? "26px" : "18px"};
          `};
      `}

      ${position === "top" && (0, _styledComponents.css)`
        padding: ${size === "large" ? "2px;" : "0px;"}
          ${isTabSelected && (0, _styledComponents.css)`
            padding-bottom: 0px;
          `}
          ${(error || warning || info) && (0, _styledComponents.css)`
        padding-bottom: ${size === "large" ? "4px;" : "2px;"}
        padding-right: ${size === "large" ? "18px;" : "14px;"}

        &:hover {
          padding-bottom: ${size === "large" ? "4px;" : "2px;"}
        }
      `};
      `}
    `}
`;
exports.StyledTitleContent = StyledTitleContent;
const StyledTabTitle = _styledComponents.default.li`
  background-color: transparent;
  display: inline-block;
  font-weight: bold;
  height: 100%;
  position: relative;

  ${({
  position,
  borders,
  noRightBorder,
  noLeftBorder
}) => `
      ${position === "top" && (0, _styledComponents.css)`
          ${borders && !(noRightBorder || noLeftBorder) && (0, _styledComponents.css)`
            &:not(:first-of-type) {
              margin-left: -1px;
            }
          `}
        `}
      ${position === "left" && (0, _styledComponents.css)`
          ${borders && (0, _styledComponents.css)`
            &:not(:first-of-type) {
              margin-top: -1px;
            }
          `}
        `}
    `}

  &:first-child {
    margin-left: 0;
  }

  ${({
  isTabSelected,
  theme
}) => !isTabSelected && (0, _styledComponents.css)`
      &:hover {
        background: ${theme.tab.background};
        color: ${theme.text.color};
        outline: none;
      }
      &:focus {
        color: ${theme.text.color};
        outline: none;
      }
    `}

  ${({
  isTabSelected,
  theme,
  alternateStyling,
  error,
  warning,
  info,
  size,
  isInSidebar,
  position
}) => isTabSelected && (0, _styledComponents.css)`
    ${!isInSidebar && "z-index: 1;"}
    color: ${theme.text.color};
    background-color: ${theme.colors.white};

    ${alternateStyling && (0, _styledComponents.css)`
        border-bottom: 2px solid ${theme.tab.background};
      `}

    ${!alternateStyling && (0, _styledComponents.css)`
        padding-bottom: 2px;
      `}

    ${size === "large" && (0, _styledComponents.css)`
        ${position === "top" && `
          padding-bottom: ${alternateStyling ? "3px" : "4px"};
          `}
      `}
    ${(error || warning || info) && (0, _styledComponents.css)`
        padding-bottom: 0px;
      `}

    &:focus {
      outline: ${isInSidebar ? "none;" : `2px solid ${theme.colors.focus};`}
    }

    &:hover {
      background-color: ${theme.colors.white};
      border-bottom-color: ${alternateStyling ? `${theme.tab.background};` : `${theme.colors.primary};`}
      color: ${theme.text.color};
      cursor: default;
    }
  `}
  
  ${({
  position,
  size,
  borders,
  theme,
  alternateStyling,
  error,
  warning,
  info
}) => position === "left" && (0, _styledComponents.css)`
      background-color: transparent;
      border-bottom: 0px;

      ${!borders && (0, _styledComponents.css)`
        ${StyledTitleContent} {
          border-bottom: none;
        }
      `}

      ${!alternateStyling && (0, _styledComponents.css)`
        border-right: 2px solid ${theme.tab.background};
      `}

      display: block;
      height: auto;
      margin-left: 0px;

      &:first-child {
        margin-top: 0;
      }

      &:hover {
        ${alternateStyling && `border-right-color: ${theme.tab.background};`}
      }

      ${({
  isTabSelected
}) => isTabSelected && (0, _styledComponents.css)`
          ${alternateStyling && (0, _styledComponents.css)`
            border-right-color: ${theme.tab.background};
          `}

          ${!alternateStyling && (0, _styledComponents.css)`
            border-right: none;
            padding-bottom: 0px;

            ${StyledTitleContent} {
              ${!(error || warning || info) && `margin-right: 2px;`}
              border-right: none;
            }
          `}
    
          background-color: ${theme.colors.white};

          ${size === "large" && (0, _styledComponents.css)`
            & ${StyledTitleContent} {
              padding-right: 22px;
            }
          `}

          &:hover {
            ${alternateStyling && ` border-right-color: ${theme.tab.background};`}
            background-color: ${theme.colors.white};
            ${(error || warning || info) && `border-right-color: ${theme.colors.error};`}
          }

          &:focus {
            ${(error || warning || info) && `border-right-color: ${theme.colors.error};`}
          }
        `}
    `}

  ${({
  alternateStyling,
  theme,
  isTabSelected,
  isInSidebar
}) => alternateStyling && (0, _styledComponents.css)`
      &:focus {
        background-color: ${theme.tab.background};
      }

      &:hover {
        background-color: ${isTabSelected ? `${theme.tab.background};` : `${theme.tab.altHover};`};
      }

      ${isTabSelected && (0, _styledComponents.css)`
        background-color: ${theme.tab.background};
      `}

      ${isInSidebar && `padding-bottom: 1px;`}
    `}
`;
exports.StyledTabTitle = StyledTabTitle;
const StyledLayoutWrapper = _styledComponents.default.div`
  ${({
  hasCustomLayout
}) => hasCustomLayout && (0, _styledComponents.css)`
      flex-grow: 2;
      min-width: 100px;
    `}

  ${({
  hasCustomLayout,
  titlePosition,
  hasCustomSibling
}) => !hasCustomLayout && (0, _styledComponents.css)`
      display: inline-flex;

      ${({
  theme
}) => (0, _styledComponents.css)`
        position: relative;
        top: -1px;
        ${hasCustomSibling && (0, _styledComponents.css)`
          left: 4px;
        `}
        ${!hasCustomSibling && (0, _styledComponents.css)`
          ${titlePosition === "before" ? `left: ${theme.spacing}px;` : `right: ${theme.spacing}px;`}
        `}
      `}

      ${_icon.default} {
        height: 20px;
      }

      ${_validationIcon.default} {
        z-index: 10;

        ${_icon.default} {
          height: 16px;
          left: -2px;
          top: 3px;
        }
      }
    `}
`;
exports.StyledLayoutWrapper = StyledLayoutWrapper;
const StyledSelectedIndicator = _styledComponents.default.div`
  position: absolute;
  z-index: 5;

  ${({
  position,
  size,
  theme
}) => position === "top" && (0, _styledComponents.css)`
      bottom: 0px;
      left: 0px;
      box-shadow: inset 0px ${size === "large" ? "-4px" : "-2px"} 0px
        ${theme.colors.primary};
      width: 100%;
      height: ${size === "large" ? "4px" : "2px"};
    `}

  ${({
  position,
  size,
  theme
}) => position === "left" && (0, _styledComponents.css)`
      top: 0px;
      right: 0px;
      box-shadow: inset ${size === "large" ? "-4px" : "-2px"} 0px 0px 0px
        ${theme.colors.primary};
      height: 100%;
      width: ${size === "large" ? "4px" : "2px"};
    `}
`;
exports.StyledSelectedIndicator = StyledSelectedIndicator;
StyledTabTitle.propTypes = {
  position: _propTypes.default.oneOf(["top", "left"]),
  size: _propTypes.default.oneOf(["default", "large"]),
  borders: _propTypes.default.bool
};
StyledTabTitle.defaultProps = {
  theme: _base.default,
  position: "top",
  size: "default",
  borders: false
};
StyledLayoutWrapper.propTypes = {
  hasCustomLayout: _propTypes.default.bool,
  titlePosition: _propTypes.default.oneOf(["before", "after"])
};
StyledLayoutWrapper.defaultProps = {
  theme: _base.default,
  titlePosition: "before"
};
StyledTitleContent.propTypes = {
  position: _propTypes.default.oneOf(["top", "left"]),
  size: _propTypes.default.oneOf(["default", "large"]),
  borders: _propTypes.default.bool,
  error: _propTypes.default.bool,
  warning: _propTypes.default.bool,
  info: _propTypes.default.bool,
  noLeftBorder: _propTypes.default.bool,
  noRightBorder: _propTypes.default.bool,
  hasSiblings: _propTypes.default.bool
};
StyledTitleContent.defaultProps = {
  theme: _base.default,
  position: "top",
  size: "default",
  borders: false
};
StyledSelectedIndicator.propTypes = {
  position: _propTypes.default.oneOf(["top", "left"]),
  size: _propTypes.default.oneOf(["default", "large"])
};
StyledSelectedIndicator.defaultProps = {
  theme: _base.default,
  position: "top",
  size: "default"
};